import style from './index.module.scss';

function NavMenu({ menu }) {
    let soloMenuItem = [];
    return (
        <nav className={style.container}>
            {menu &&
                Object.values(menu).map((menuItem, id) => {
                    if (menuItem?.children?.length > 0) {
                        return (
                            <div className={style.menuCol}>
                                <a
                                    key={id}
                                    href={menuItem?.url === '#' ? undefined : menuItem.url}
                                    className={style.firstLevel}
                                >
                                    {menuItem.title}
                                </a>
                                {Object.values(menuItem.children).map((childItem, id) => {
                                    return (
                                        <a
                                            key={id}
                                            href={childItem?.url === '#' ? undefined : childItem.url}
                                            className={style.secondLevel}
                                        >
                                            <span className={style.marker} />
                                            <span>{childItem.title}</span>
                                        </a>
                                    );
                                })}
                            </div>
                        );
                    } else {
                        soloMenuItem.push(
                            <a
                                key={id}
                                href={menuItem?.url === '#' ? undefined : menuItem.url}
                                className={style.firstLevel}
                            >
                                {menuItem.title}
                            </a>,
                        );
                        return <></>;
                    }
                })}
            <div className={style.menuCol} style={{ gap: '15px' }}>
                {soloMenuItem}
            </div>
        </nav>
    );
}

export default NavMenu;
